import {React, useState, useEffect} from 'react';
import {useDispatch } from 'react-redux';
import {updateTableActions} from '../../store/update-table-slice';
import '../../App.css'
import axios from 'axios';
import { Grid, TextField, Box, Button,createTheme, ThemeProvider, Paper, Stack,FormControl, FormControlLabel, InputLabel, Select, MenuItem, Checkbox, FormHelperText, Typography} from '@mui/material';
import { CalendarMonth, RestartAlt, ArrowForwardIos, } from '@mui/icons-material';
import * as employeeService from '../../services/employeeService';
import Popup from '../Popup';
import LeaveInfoTable from '../table-data/LeaveInfoTable';
import LeaveBalanceTable from '../table-data/LeaveBalanceTable';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';
import AddEmpEarningComponent from './AddEmpEarningComponent';

const options = employeeService.getDepartmentCollection();

const initialFValues = {
  id: 0,
  leaveTypeID: '',
  leaveReason: '',
  fromDate: '', 
  toDate: '',   
  leaveDate: '',
  totalLeaveDays: '',
  isHalfDayLeave: false,
  isMedicalLeave: false,
}

const RequiredLabel = ({ label }) => (
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

function LeaveDataMaster(props){

  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [openPopup1, setOpenPopup1] = useState(false);
  const [openPopup2, setOpenPopup2] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // Close modal when notification appears for successful addition
  useEffect(() => {
    if (notify.isOpen && notify.type === 'success') {
      // Close the modal after a short delay to show the notification
      const timer = setTimeout(() => {
        // Call the parent's function to close the modal
        if (props.onCloseModal) {
          props.onCloseModal();
        }
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [notify, props.onCloseModal]);

  useEffect(() => {
    async function myFunc(){
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/leave-master/view`);
        setLeaveTypes(response.data);
      } catch (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      }
    }
    myFunc();
  }, []);


  const validate = () => {
    let temp = {};
    temp.leaveReason = values.leaveReason ? "" : "This field is required."

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x === "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }

  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
          ...errors,
          [name]: ''
      });
    }
  }

  const handleHalfDayChange = (e) => {
    const isHalfDay = e.target.checked;
    setValues({
      ...values,
      isHalfDayLeave: isHalfDay,
      // Reset date fields when switching between half day and full day
      fromDate: isHalfDay ? '' : values.fromDate,
      toDate: isHalfDay ? '' : values.toDate,
      leaveDate: isHalfDay ? values.leaveDate : ''
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      // Create a new object to send to the API
      let dataToSend = { ...values };

      // Remove empty date fields or set to null for backend processing
      if (dataToSend.fromDate === '') dataToSend.fromDate = null;
      if (dataToSend.toDate === '') dataToSend.toDate = null;
      if (dataToSend.leaveDate === '') dataToSend.leaveDate = null;

      let empID = props.fetch_id;
      if (props.fetch_id === 9999) {
        empID = props.employeeID;
      }
      
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/employee-master/add-emp-leave/` + empID, dataToSend)
      .then(function (response) {
      if(response.status === 200) {
        setNotify({
          isOpen: true,
          message: 'Successfully added',
          type: 'success'
        }); 
        dispatch(updateTableActions.startUpdateEmpLeave());
        // Reset form after successful submission
        resetForm();
      }
      })
      .catch(function (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      });
    }
  }

  const theme = createTheme({
    palette: {
      primary: { main: '#0b418e' },
      blueGrey: {
        main: '#607d8b',
      },
      lightGreen: {
        main: '#94B49F',
      },
      lightRed: {
        main: '#FA7070',
      },
      lightYellow: {
        main: '#CCD6A6',
      },
      lightBlue: {
        main: '#47B5FF',
      },
    },
  });

  return(
  <ThemeProvider theme={theme}>
    <Box sx={{display: "flex" ,justifyContent: "center", margin: "10px", marginTop: "-20px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={0}  variant="outlined" sx={{width: "500px"}}>
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>LEAVE DATA MASTER</Typography> </Grid>
          <Grid item> <CalendarMonth style={{marginLeft: "-30px"}}  sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={2} sx={{margin: "30px"}}>

          <FormControl
            variant="outlined"
            {...(errors.departmentId && {error:true} )}>
              <InputLabel>Leave Type</InputLabel>
              <Select
                label="Leave Type"
                name="leaveTypeID"
                value={values.leaveTypeID}
                onChange={handleInputChange}
              >
                <MenuItem value="">None</MenuItem>
                  {
                    leaveTypes.map(
                      item => (<MenuItem key={item.leave_type_id} value={item.leave_type_id}>{item.leave_type}</MenuItem>)
                    )
                  }

              </Select>
              { errors.leaveType && <FormHelperText>{errors.leaveType}</FormHelperText>}
          </FormControl>

            <TextField
              variant="outlined"
              name="leaveReason"
              label={<RequiredLabel label="Reason For Leave"/>}
              value={values.leaveReason}
              onChange={handleInputChange}
              {...(errors.leaveReason && {error:true, helperText: errors.leaveReason} )}
            />

            {!values.isHalfDayLeave ? (
              <Stack className="form-input-row" direction="row" spacing={2}>
                <TextField
                  variant="outlined"
                  className="date-picker"
                  type="date"
                  label="From Date"
                  name="fromDate"
                  value={values.fromDate}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />

                <TextField
                  variant="outlined"
                  className="date-picker"
                  type="date"
                  label="To Date"
                  name="toDate"
                  value={values.toDate}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Stack>
            ) : (
              <TextField
                variant="outlined"
                className="date-picker"
                type="date"
                label="Date of Leave"
                name="leaveDate"
                value={values.leaveDate}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
              />
            )}

          <Stack className="form-input-row" direction="row" spacing={2}>
              <FormControl>
                <FormControlLabel
                  control={<Checkbox
                          name="isHalfDayLeave"
                          color="primary"
                          checked={values.isHalfDayLeave}
                          onChange={handleHalfDayChange}
                          />}
                          label="Half Day Leave"
                          />
              </FormControl>
          </Stack>

              <Grid container className="form-btn-container">
                <Grid item>
                <Button className="form-btn" variant="contained" color="lightRed" onClick={resetForm} endIcon={<RestartAlt />} >Reset</Button>
                </Grid>
                <Grid item>
                <Button className="form-btn" variant="contained" type="submit" color="lightBlue" endIcon={<ArrowForwardIos sx={{width: "18px", height: "18px"}} />} >Submit</Button>
                </Grid>
              </Grid>

            </Stack>
            <Stack className="end-align" >
                <Button className="form-btn" variant="outlined" onClick={() => setOpenPopup(true)} endIcon={<ArrowForwardIos/>} >Next</Button>
            </Stack>
        </form>
        <Popup
            title="Company Bank Accounts Form"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <AddEmpEarningComponent employeeID={props.employeeID} fetch_id={9999}/>
          </Popup>
      </Paper>
      
    </Box>

    <Popup
        title="Leave Information"
        openPopup={openPopup1}
        setOpenPopup={setOpenPopup1}
      >
        <LeaveInfoTable/>
      </Popup>
      <Popup
        title="Leave Balance"
        openPopup={openPopup2}
        setOpenPopup={setOpenPopup2}
      >
        <LeaveBalanceTable/>
      </Popup>

      
      <Notification
        notify={notify}
        setNotify={setNotify} 
      />
  
  </ThemeProvider>

  )
}

export default LeaveDataMaster;